import React from "react";

const CustomSwitch = ({
  rows,
  hightlightedElement,
  style = false,
  className = "",
  selectedStyle
}) => {
  return (
    <div className={`switch-container ${className}`} >
      {rows.map((item, rowIndex) => (
        <React.Fragment key={rowIndex}>
          {item.header ? (
            <div className="heading_wrapper">
              <div>{item.firstValue}</div>
              <div>{item.lastValue}</div>
            </div>
          ) : null}

          {!item.header && (
            <div
              className="row"
              style={
                style
                  ? {...style, }
                  : {}
              }
            >
              {Object.keys(item).map((element, index) => (
                <>
                  {item[element] ? (
                    <div
                      key={index}
                      className={
                        index === hightlightedElement
                          ? "highlighted_element"
                          : "non-highlighted"
                      }
                      style={
                        style
                          ? {...style}
                          : {}

                       
                      }
                    >
                      {item[element]}
                    </div>
                  ) : null}
                </>
              ))}
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CustomSwitch;
